import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { useIsDesktopDimension } from "../../../../hooks/useGetDimensionGroup";
import { CompactParameter } from "../CompactParameter";
import styles from "./styles.module.pcss";
var cn = classNames.bind(styles);
export var CompactParameters = /*#__PURE__*/memo(function (_ref) {
  var compactParameters = _ref.compactParameters,
    isDark = _ref.isDark,
    isYandex = _ref.isYandex,
    isFirst = _ref.isFirst,
    isLast = _ref.isLast,
    cardType = _ref.cardType,
    badgeClassName = _ref.badgeClassName;
  var handleClick = function handleClick(e) {
    return e.preventDefault();
  };
  var IsDesktop = useIsDesktopDimension();
  return /*#__PURE__*/React.createElement("ul", {
    className: cn('compact-parameters'),
    onClick: handleClick,
    "data-t-id": "components-CompactParameters"
  }, compactParameters === null || compactParameters === void 0 ? void 0 : compactParameters.map(function (compactParameter) {
    return /*#__PURE__*/React.createElement("li", {
      className: cn('badge', 'badge__compact', {
        'badge__compact--dark': isDark,
        'badge__compact--yandex': isYandex,
        'badge__compact--sharing': !!compactParameter.size && IsDesktop
      }),
      key: compactParameter.value
    }, /*#__PURE__*/React.createElement(CompactParameter, {
      badgeClassName: badgeClassName,
      cardType: cardType,
      compactParameter: compactParameter,
      isFirst: isFirst,
      isLast: isLast,
      isSharing: !!compactParameter.size && IsDesktop,
      isYandex: isYandex
    }));
  }));
});